<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item>组合购管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">组合购管理</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handelToGoCreate"
          >添加组合购</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="组合购名称">
          <el-input
            v-model.trim="query.name_keyword"
            placeholder="输入名称/产品名称"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div class="results card">
      <div class="values-header">
        <p class="title">组合购列表</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="id"
            label="ID"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="组合购名称"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="description"
            label="组合购描述"
            show-overflow-tooltip
            align="left"
          >
            <template slot-scope="scope">
              {{ scope.row.description? scope.row.description:'无'}}
            </template>
          </el-table-column>
          <el-table-column
            prop="product_count"
            label="产品数量"
            width="80"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                type="danger"
                v-show="scope.row.status == 0"
              >已下线</el-tag>
              <el-tag
                type="success"
                v-show="scope.row.status == 1"
              >进行中</el-tag>
              <el-tag
                type="info"
                v-show="scope.row.status == 2"
              >未开始</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="有效期"
            width="200"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span>
                {{ $moment(scope.row.start_time).format("YYYY.MM.DD") }}
                -
              </span>
              <span>
                {{ $moment(scope.row.end_time).format("YYYY.MM.DD") }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="order_amount"
            label="创建时间"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="creator"
            label="创建人"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              {{ formateCreator(scope.row.creator)}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="200"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToCopy(scope.row)"
              >复制链接</el-button>
              <el-button
                size="mini"
                type="text"
                @click="handleToEdit(scope.row)"
              >编辑</el-button>
              <el-button
                class="remove-text-button"
                size="mini"
                type="text"
                @click="handleToRemove(scope.row, scope.$index)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { bucketCourselist, bucketCourseDelete } from "@/api/operation";



export default {
  components: {
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      filter: {

      }
    };
  },
  created() {
    this.fetchList();
    this.$store.dispatch('getAdminList')

  },
  methods: {
    fetchList() {
      bucketCourselist(this.query).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    handelToGoCreate() {
      this.$router.push('/packagepurchase/create')
    },

    handleToRemove(row) {
      this.$confirm("确定要删除此条组合购吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        bucketCourseDelete({ id: row.id }).then((res) => {
          this.fetchList(true);
        });
      })
    },
    handleToEdit(row) {
      this.$router.push(`/packagepurchase/edit/${row.id}`)
    },
    formateCreator(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          if (this.$store.state.adminList.findIndex((v) => { return v.id == val }) > -1) {
            return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
          } else {
            return "无"
          }
        } else {
          return "无"
        }
      }
    },
    handleToCopy(row) {
      const input = document.createElement("textarea");
      if (window.location.host.includes('admin.kaoyanbox.com')) {
        input.value = `${window.location.protocol}//h5.kaoyanbox.com/bucketCourse/detail/${row.id}`
      } else {
        input.value = `${window.location.protocol}//h5.kaoyanbox.net/bucketCourse/detail/${row.id}`
      }
      this.$copyText(input.value).then((e) => {
        this.$notify.success({
          title: "提示",
          message: "复制成功",
          type: "success",
        });
      });
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .el-link {
    font-size: 14px;
    margin: 0px 5px;
  }
}
</style>
